import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import image from '../../img/Bonus/image.png';
import button from '../../img/Bonus/button.png'

import Fade from 'react-reveal/Fade';

import rec from '../../img/Bonus/rec.webp';

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#F8F8F8]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[50px] xl:mt-[90px]">
                <div className="flex flex-col md:flex-row justify-between">
                    <div>
                        <div className="flex md:flex-col flex-row gap-[6px] xl:gap-0">
                            <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather">{t('bonus.1')}</p>
                            <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather">{t('bonus.2')}</p>
                        </div>
                        <p className="mt-[45px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd md:hidden block"><Trans>{t('bonus.3')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd md:hidden block"><Trans>{t('bonus.4')}</Trans></p>
                        <Button className={"mt-[30px] xl:mt-[40px]"}/>
                    </div>
                    <div className="mt-[50px] md:mt-0">
                        <div className="relative">
                            <img src={image} alt="" />  
                            <Fade right duration={2000}><img src={button} className="absolute inset-[10px] hidden md:block" alt="" /></Fade>
                        </div>
                        <p className="mt-[45px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd hidden md:block"><Trans>{t('bonus.3')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd hidden md:block"><Trans>{t('bonus.4')}</Trans></p>
                    </div>
                </div>
                <div className="relative mt-[100px] xl:mt-[65px] xl:h-[398px] flex flex-col">
                    <img src={rec} alt="" className="absolute hidden xl:block"/>
                    <div className="grid grid-cols-1 md:grid-cols-2 relative mx-auto xl:mt-[65px] md:gap-x-[20px] xl:gap-x-[175px] gap-y-[15px] xl:gap-y-[50px]">
                        <div className="xl:w-[383px]">
                            <div className="h-[2px] bg-[#0000004D] xl:bg-white"></div>
                            <p className="merriweather italic font-[700] text-[18px] text-black xl:text-white mt-[15px]">{t('bonus.5')}</p>
                            <p className="inter text-[14px] xl:text-[16px] font-[300] text-black xl:text-white mt-[15px]">{t('bonus.6')}</p>
                        </div>
                        <div className="xl:w-[383px]">
                            <div className="h-[2px] bg-[#0000004D] xl:bg-white"></div>
                            <p className="merriweather italic font-[700] text-[18px] text-black xl:text-white mt-[15px]">{t('bonus.7')}</p>
                            <p className="inter text-[14px] xl:text-[16px] font-[300] text-black xl:text-white mt-[15px]">{t('bonus.8')}</p>
                        </div>
                        <div className="xl:w-[383px]">
                            <div className="h-[2px] bg-[#0000004D] xl:bg-white"></div>
                            <p className="merriweather italic font-[700] text-[18px] text-black xl:text-white mt-[15px]">{t('bonus.9')}</p>
                            <p className="inter text-[14px] xl:text-[16px] font-[300] text-black xl:text-white mt-[15px]">{t('bonus.10')}</p>
                        </div>
                        <div className="xl:w-[383px]">
                            <div className="h-[2px] bg-[#0000004D] xl:bg-white"></div>
                            <p className="merriweather italic font-[700] text-[18px] text-black xl:text-white mt-[15px]">{t('bonus.11')}</p>
                            <p className="inter text-[14px] xl:text-[16px] font-[300] text-black xl:text-white mt-[15px]">{t('bonus.12')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;